import { getWdacStatusLabel } from 'src/utils/enums/wdacStatus';
import {
  POLICY_DEVICE_MEMBERSHIP,
  getPolicyDeviceMembershipOptions,
} from 'src/utils/enums/uiOnly/policyDeviceMembership';

// A device without the policy has no version or applied date, so those read as a dash there.
export const DEVICE_COLUMNS = [
  { key: 'deviceName', label: 'Device', width: '18%', wrap: true },
  { key: 'policyVersion', label: 'Version', width: '10%' },
  { key: 'lastAppliedDate', label: 'Last Applied', width: '13%' },
  { key: 'osVersion', label: 'OS Version', width: '13%', wrap: true },
  { key: 'osSku', label: 'OS SKU', width: '12%', wrap: true },
  { key: 'osType', label: 'OS Type', width: '10%' },
  { key: 'logCollectorVersion', label: 'Log Collector', width: '12%' },
  {
    key: 'wdacDeviceStatus',
    label: 'WDAC Status',
    width: '12%',
    render: row => getWdacStatusLabel(row.wdacDeviceStatus),
  },
];

export const DEFAULT_DEVICE_FILTERS = {
  membership: POLICY_DEVICE_MEMBERSHIP.WithPolicy,
};

export const DEVICE_FILTER_OPTIONS = [
  {
    key: 'membership',
    type: 'radio',
    label: 'Devices',
    options: getPolicyDeviceMembershipOptions(),
  },
];
